import LeaveRoutePrompt from "pages/ManagementPage/LeaveRoutePrompt/LeaveRoutePrompt";

export default LeaveRoutePrompt;
